import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const ACTIVITY_EXPORT_MAX_DAYS = 14;

export function isActivityExportRangeWiderThanMax(from: string, to: string): boolean {
  const start = dayjs.utc(from);
  const end = dayjs.utc(to);

  if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
    return false;
  }

  const inclusiveDays = end.startOf('day').diff(start.startOf('day'), 'day') + 1;
  return inclusiveDays > ACTIVITY_EXPORT_MAX_DAYS;
}

export function clampActivityExportDateRange(from: string, to: string): { from: string; to: string } {
  if (!isActivityExportRangeWiderThanMax(from, to)) {
    return { from, to };
  }

  const end = dayjs.utc(to);
  const clampedFrom = end.startOf('day').subtract(ACTIVITY_EXPORT_MAX_DAYS - 1, 'day');

  return {
    from: clampedFrom.toISOString(),
    to,
  };
}
